import { render, staticRenderFns } from "./canteen.vue?vue&type=template&id=b6839b1c&scoped=true&"
import script from "./canteen.vue?vue&type=script&lang=js&"
export * from "./canteen.vue?vue&type=script&lang=js&"
import style0 from "./canteen.vue?vue&type=style&index=0&id=b6839b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6839b1c",
  null
  
)

export default component.exports